module.exports = __webpack_public_path__ + "static/media/orange_drink.8f9389ac.svg";